class CapChangeView {
  constructor(config) {
    this.config = config
    this.errors = {}
  }

  checkPermission(options = {}) {
    if (options === undefined || options.newView === undefined) {
      return Boolean(this.config)
    }

    let newView = options.newView.viewRef

    if (
      newView.schoolYear &&
      !this._checkConfigField('schoolYear', newView.schoolYear, options.schoolYear)
    ) {
      return false
    }
    if (
      newView.district &&
      !this._checkConfigField('district', newView.district, options.district)
    ) {
      return false
    }
    if (
      newView.partition &&
      !this._checkConfigField('partition', newView.partition, options.partition)
    ) {
      return false
    }
    if (
      newView.vendor &&
      !this._checkConfigField('vendor', newView.vendor, options.vendor)
    ) {
      return false
    }

    return Boolean(this.config)
  }

  displayCanChangeViewField(fieldKey) {
    if (this.config[fieldKey] === undefined) {
      return false
    }
    if (typeof this.config[fieldKey] === 'boolean') {
      return Boolean(this.config[fieldKey])
    }
    else {
      return this.config[fieldKey].canChange
    }
  }

  displayCanDeleteViewField(fieldKey, viewRef) {
    if (fieldKey === 'schoolYear') {
      return false
    }

    if (this.config[fieldKey] === undefined) {
      return true
    }
    if (typeof this.config[fieldKey] === 'boolean') {
      return Boolean(this.config[fieldKey])
    }
    else {
      if (
        this.config[fieldKey].maxSelect
        && this.config[fieldKey].maxSelect == 1
      ) {
        return false
      }
      else if (this.config[fieldKey].required) {
        return viewRef[fieldKey].length > 1
      }
      else {
        return true
      }
    }
  }

  displayCanAddViewField(fieldKey) {
    if (fieldKey === 'schoolYear') {
      return false
    }

    if (this.config[fieldKey] === undefined) {
      return true
    }
    if (typeof this.config[fieldKey] === 'boolean') {
      return Boolean(this.config[fieldKey])
    }
    else {
      if (
        this.config[fieldKey].maxSelect
        && this.config[fieldKey].maxSelect == 1
      ) {
        return false
      }
      else if (this.config[fieldKey].options) {
        return this.config[fieldKey].options.length > 1
      }
      else {
        return false
      }
    }
  }

  requiredChangeViewField(fieldKey) {
    if (this.config[fieldKey] === undefined) {
      return false
    }

    if (typeof this.config[fieldKey] === 'boolean') {
      return false
    }

    return this.config[fieldKey].required === true
  }

  optionsChangeViewField(fieldKey) {
    return this.config[fieldKey].options
  }

  maxSelect(fieldKey) {
    if (fieldKey === 'schoolYear') {
      return 1
    }

    return this.config[fieldKey]?.maxSelect
  }

  _checkConfigField(fieldKey, newViewSection) {
    let fieldConfig = this.config[fieldKey]
    if (fieldConfig === undefined) {
      return true
    }

    if (fieldConfig.required) {
      if (newViewSection == undefined
        || Array.isArray(newViewSection) && newViewSection.length === 0) {
        this.errors[fieldKey] = 'field is required'
        return false
      }
    }

    if (fieldConfig.maxSelect) {
      if (newViewSection.length > fieldConfig.maxSelect) {
        this.errors[fieldKey] = `max number of options greater than ${fieldConfig.maxSelect}`
        return false
      }
    }

    if (fieldConfig.options) {
      for (const newViewValue of newViewSection) {
        if (!fieldConfig.options.includes(newViewValue)) {
          this.errors[fieldKey] = 'value not a valid option'
          return false
        }
      }
    }

    return true
  }
}

function key() {
  return 'change_view'
}

function create(config) {
  return new CapChangeView(config)
}

export default {
  key,
  create,
}
